import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const ExportIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.372 2a.833.833 0 0 0-.58 1.43l1.354 1.355h-.766c-6.583 0-11.938 5.355-11.938 11.938a.833.833 0 1 0 1.666 0A10.26 10.26 0 0 1 18.38 6.451h.766L17.79 7.805a.833.833 0 1 0 1.178 1.178l2.705-2.705a.833.833 0 0 0-.004-1.325l-2.7-2.7A.833.833 0 0 0 18.371 2zm-12.763.009A3.622 3.622 0 0 0 2 5.618v12.77a3.622 3.622 0 0 0 3.61 3.61h12.77a3.622 3.622 0 0 0 3.61-3.61v-4.441a.833.833 0 1 0-1.666 0v4.442c0 1.083-.86 1.943-1.944 1.943H5.61a1.931 1.931 0 0 1-1.944-1.943V5.618c0-1.083.86-1.944 1.943-1.944h4.442a.833.833 0 1 0 .024-1.665H5.609z"
        fillRule="nonzero"
      />
    </SvgIcon>
  );
};

export default ExportIcon;
